<template lang="pug">
v-card.custom-card(outlined, style="position: relative")
  v-progress-linear.cadastro-loading-bar(
    v-if="carregando",
    indeterminate,
    color="blue",
    height="2"
  )

  .d-flex.align-center.justify-space-between.gap-2.cadastro-header
    .cadastro-title {{ titulo }}
    v-spacer
    .d-flex.align-center.gap-2.cadastro-origem(v-if="habilitado && empresaOrigem")
      .cadastro-origem-label Origem
      .cadastro-origem-numero {{ empresaOrigem.codigoempresa }}
      .cadastro-origem-nome.text-truncate {{ empresaOrigem.fantasia || empresaOrigem.razaosocial }}
  v-divider

  .cadastro-content.pa-0(v-if="!carregando")
    //- Estado vazio: nenhuma empresa selecionada
    .cadastro-empty.justify-center.align-center.text-center.py-8(v-if="!habilitado")
      v-icon.empty-state-icon(size="48", color="blue lighten-3") {{ iconeSemSelecao }}
      .empty-state-subtitle.mt-2 {{ textoSemSelecao }}

    //- Formulário de cadastro
    .cadastro-scroll-wrapper(v-else)
      v-form(ref="form", :disabled="somenteLeitura", @submit.prevent)
        v-row.ma-0(dense)
          //- ===== Coluna esquerda =====
          v-col(cols="12", md="7")
            .cadastro-bloco
              .cadastro-bloco-titulo Identificação
              v-row.mt-0(dense)
                v-col(cols="12", sm="5")
                  v-text-field.preview-field(
                    label="Código Empresa",
                    :value="form.codigoempresa",
                    @input="atualizar('codigoempresa', apenasNumeros($event, 3))",
                    maxlength="3",
                    :rules="[rules.codigoEmpresa]",
                    :error-messages="codigoVerificado ? erroCodigoAoSalvar : []",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12", sm="7")
                  v-text-field.preview-field(
                    label="Razão Social",
                    :value="form.razaosocial",
                    @input="atualizar('razaosocial', $event)",
                    maxlength="50",
                    :rules="[rules.obrigatorio]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12")
                  v-text-field.preview-field(
                    label="Fantasia",
                    :value="form.fantasia",
                    @input="atualizar('fantasia', $event)",
                    maxlength="50",
                    :rules="[rules.obrigatorio]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12")
                  v-select.preview-field(
                    label="Caracterização",
                    :value="form.tipoempresa",
                    @change="atualizar('tipoempresa', $event)",
                    :items="caracterizacoes",
                    item-text="tipo_empresa",
                    item-value="tipoempresa",
                    :rules="[rules.obrigatorioValor]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12")
                  v-select.preview-field(
                    label="Grupo",
                    :value="form.codigogrupo",
                    @change="atualizar('codigogrupo', $event)",
                    :items="grupos",
                    :item-text="grupoItemText",
                    :item-value="grupoItemValue",
                    :disabled="somenteLeitura || !grupos.length",
                    :hint="!grupos.length ? 'Nenhum grupo disponível' : ''",
                    persistent-hint,
                    :rules="[rules.obrigatorioValor]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )

            .cadastro-bloco.mt-3
              .cadastro-bloco-titulo Endereço
              v-row.mt-0(dense)
                v-col(cols="12")
                  v-text-field.preview-field(
                    label="Endereço",
                    :value="form.endereco",
                    @input="atualizar('endereco', $event)",
                    maxlength="50",
                    :rules="[rules.obrigatorio]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12", sm="4")
                  v-text-field.preview-field(
                    label="Número",
                    :value="form.numero",
                    @input="atualizar('numero', $event)",
                    maxlength="10",
                    :rules="[rules.obrigatorio]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12", sm="8")
                  v-text-field.preview-field(
                    label="Bairro",
                    :value="form.bairro",
                    @input="atualizar('bairro', $event)",
                    maxlength="30",
                    :rules="[rules.obrigatorio]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12", sm="9")
                  v-autocomplete.preview-field(
                    label="Cidade",
                    :value="form.codigoibge",
                    @change="selecionarCidade",
                    :items="cidades",
                    :item-text="cidadeItemText",
                    :item-value="cidadeItemValue",
                    :loading="carregandoCidades",
                    :disabled="somenteLeitura || (!cidades.length && !carregandoCidades)",
                    :rules="[rules.obrigatorioValor]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12", sm="3")
                  v-text-field.preview-field(
                    label="UF",
                    :value="form.uf",
                    readonly,
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12", sm="5")
                  v-text-field.preview-field(
                    label="CEP",
                    :value="form.cep",
                    @input.native="aoDigitar($event, 'cep', 8, false)",
                    @blur="atualizar('cep', formatarCep(form.cep))",
                    maxlength="9",
                    :rules="[rules.cep]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )

            .cadastro-bloco.mt-3
              .cadastro-bloco-titulo Contato
              v-row.mt-0(dense)
                v-col(cols="12")
                  v-text-field.preview-field(
                    label="Telefone",
                    :value="form.telefone",
                    @input="atualizar('telefone', $event)",
                    maxlength="20",
                    :rules="[rules.obrigatorio]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12")
                  v-text-field.preview-field(
                    label="E-mail",
                    :value="form.email",
                    @input="atualizar('email', $event)",
                    maxlength="500",
                    :rules="[rules.email]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )

          //- ===== Coluna direita: documento =====
          v-col(cols="12", md="5")
            .cadastro-bloco
              .cadastro-bloco-titulo Documento
              v-row.mt-0(dense)
                v-col(cols="12")
                  v-radio-group.ma-0.pt-0(
                    :value="form.tipodocumento",
                    @change="definirTipoDocumento",
                    row,
                    hide-details,
                    :disabled="somenteLeitura"
                  )
                    v-radio.cadastro-radio(label="CNPJ", value="cnpj")
                    v-radio.cadastro-radio(label="CPF", value="cpf")
                v-col(cols="12")
                  v-text-field.preview-field(
                    label="CNPJ",
                    :value="form.cnpj",
                    @input.native="aoDigitar($event, 'cnpj', 14, true)",
                    @blur="atualizar('cnpj', formatarCnpj(form.cnpj))",
                    maxlength="18",
                    :disabled="somenteLeitura || form.tipodocumento !== 'cnpj'",
                    :rules="[rules.cnpj]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12")
                  v-text-field.preview-field(
                    label="CPF",
                    :value="form.cpf",
                    @input.native="aoDigitar($event, 'cpf', 11, false)",
                    @blur="atualizar('cpf', formatarCpf(form.cpf))",
                    maxlength="14",
                    :disabled="somenteLeitura || form.tipodocumento !== 'cpf'",
                    :rules="[rules.cpf]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
                v-col(cols="12")
                  v-text-field.preview-field(
                    label="CCE",
                    :value="form.cce",
                    @input="atualizar('cce', $event)",
                    maxlength="20",
                    :rules="[rules.obrigatorio]",
                    outlined,
                    dense,
                    hide-details="auto"
                  )
</template>

<script>
export default {
  name: "CadastroEmpresaCard",

  props: {
    titulo: {
      type: String,
      default: "Cadastro da empresa"
    },
    // Objeto do formulário (v-model). As alterações sobem via evento "input".
    value: {
      type: Object,
      default: () => ({})
    },
    carregando: {
      type: Boolean,
      default: false
    },
    habilitado: {
      type: Boolean,
      default: true
    },
    somenteLeitura: {
      type: Boolean,
      default: false
    },
    // Empresa que serviu de origem para os dados, exibida no cabeçalho.
    empresaOrigem: {
      type: Object,
      default: null
    },
    caracterizacoes: {
      type: Array,
      default: () => []
    },
    grupos: {
      type: Array,
      default: () => []
    },
    grupoItemText: {
      type: String,
      default: "descricao"
    },
    grupoItemValue: {
      type: String,
      default: "codigogrupo"
    },
    cidades: {
      type: Array,
      default: () => []
    },
    cidadeItemText: {
      type: String,
      default: "label"
    },
    cidadeItemValue: {
      type: String,
      default: "codigoibge"
    },
    carregandoCidades: {
      type: Boolean,
      default: false
    },
    // Códigos de empresa já utilizados na base do cliente.
    codigosEmUso: {
      type: Array,
      default: () => []
    },
    iconeSemSelecao: {
      type: String,
      default: "mdi-domain"
    },
    textoSemSelecao: {
      type: String,
      default: "Selecione uma empresa para visualizar o cadastro"
    }
  },

  data: () => ({
    // Fica true depois da primeira tentativa de salvar.
    codigoVerificado: false
  }),

  computed: {
    form() {
      return this.value || {};
    },

    erroCodigoAoSalvar() {
      const numero = Number(this.form.codigoempresa);
      if (!(numero > 0)) return "Informe um código maior que zero";
      if (this.codigosEmUso.map(Number).includes(numero)) {
        return "Código já utilizado por outra empresa";
      }
      return "";
    },

    rules() {
      return {
        obrigatorio: v => (!!v && String(v).trim().length > 0) || "Campo obrigatório",

        obrigatorioValor: v => (v !== null && v !== undefined && v !== "") || "Campo obrigatório",

        // Entre 1 e 999 e ainda não utilizado na base do cliente.
        codigoEmpresa: v => {
          const numero = Number(v);
          if (v === null || v === undefined || v === "") return "Campo obrigatório";
          if (Number.isNaN(numero)) return "Informe apenas números";
          if (numero > 999) return "Informe um código até 999";
          return true;
        },

        cep: v => {
          const digitos = this.somenteDigitos(v);
          if (!digitos) return "Campo obrigatório";
          return digitos.length === 8 || "Informe um CEP válido";
        },

        email: v => {
          if (!v || !String(v).trim()) return "Campo obrigatório";
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v)) || "Informe um e-mail válido";
        },

        cnpj: v => {
          if (this.form.tipodocumento !== "cnpj") return true;
          const limpo = this.somenteAlfanumerico(v);
          if (!limpo) return "Campo obrigatório";
          return limpo.length === 14 || "Informe um CNPJ válido";
        },

        cpf: v => {
          if (this.form.tipodocumento !== "cpf") return true;
          const limpo = this.somenteDigitos(v);
          if (!limpo) return "Campo obrigatório";
          return limpo.length === 11 || "Informe um CPF válido";
        }
      };
    }
  },

  methods: {
    // Emite o objeto completo para preservar o contrato de v-model.
    atualizar(campo, valor) {
      this.$emit("input", { ...this.form, [campo]: valor });
    },

    somenteDigitos(valor) {
      return String(valor || "").replace(/\D/g, "");
    },

    somenteAlfanumerico(valor) {
      return String(valor || "")
        .replace(/[^0-9a-zA-Z]/g, "")
        .toUpperCase();
    },

    // Mantém apenas dígitos durante a digitação, sem reposicionar o cursor.
    apenasNumeros(valor, limite) {
      return this.somenteDigitos(valor).slice(0, limite);
    },

    apenasAlfanumerico(valor, limite) {
      return this.somenteAlfanumerico(valor).slice(0, limite);
    },

    // O v-text-field não reverte o DOM quando o valor filtrado coincide com o
    // do model, o que deixaria passar um caractere além do limite. Por isso a
    // sincronização do input é feita manualmente.
    aoDigitar(evento, campo, limite, alfanumerico) {
      const alvo = evento && evento.target ? evento.target : null;
      const bruto = alvo ? alvo.value : "";
      const filtrado = alfanumerico
        ? this.apenasAlfanumerico(bruto, limite)
        : this.apenasNumeros(bruto, limite);

      if (alvo && alvo.value !== filtrado) {
        alvo.value = filtrado;
      }

      this.atualizar(campo, filtrado);
    },

    // As máscaras são aplicadas no blur para não interferir na digitação.
    formatarCep(valor) {
      const d = this.somenteDigitos(valor);
      if (d.length !== 8) return d;
      return `${d.slice(0, 5)}-${d.slice(5)}`;
    },

    formatarCnpj(valor) {
      const d = this.somenteAlfanumerico(valor);
      if (d.length !== 14) return d;
      return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
    },

    formatarCpf(valor) {
      const d = this.somenteDigitos(valor);
      if (d.length !== 11) return d;
      return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
    },

    // O documento não escolhido é gravado em branco, evitando lixo no cadastro.
    definirTipoDocumento(tipo) {
      this.$emit("input", {
        ...this.form,
        tipodocumento: tipo,
        cnpj: tipo === "cnpj" ? this.form.cnpj || "" : "",
        cpf: tipo === "cpf" ? this.form.cpf || "" : ""
      });
    },

    // O código IBGE e a UF acompanham a cidade selecionada.
    selecionarCidade(valor) {
      const cidade = this.cidades.find(c => c[this.cidadeItemValue] === valor) || null;
      this.$emit("input", {
        ...this.form,
        codigoibge: valor,
        uf: cidade ? cidade.uf || cidade.siglauf || "" : ""
      });
    },

    // Usados pela tela para validar e limpar o formulário.
    validar() {
      if (!this.$refs.form) return false;
      this.codigoVerificado = true;
      const formularioValido = this.$refs.form.validate();
      return formularioValido && !this.erroCodigoAoSalvar;
    },

    resetarValidacao() {
      this.codigoVerificado = false;
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  }
};
</script>

<style scoped>
.custom-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #d9e2ec !important;
  border-radius: 18px 6px 18px 6px !important;
  box-shadow: 0 2px 8px rgba(15, 42, 77, 0.08) !important;
}

.text-none {
  text-transform: none !important;
}

.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field.v-input--is-focused .v-input__slot {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}

.preview-field .v-input__slot:hover {
  border-color: #b1bac4;
}

.preview-field .v-input__slot,
.preview-field .v-text-field__slot input,
.preview-field .v-select__selection {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__slot {
  min-height: 36px !important;
}

.preview-field .v-input__prepend-inner .v-icon,
.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}

.preview-field .v-label {
  color: #8a94a3;
  font-size: 13px;
}

.cadastro-header {
  flex: 0 0 auto;
  min-height: 56px;
  padding: 0 18px;
  display: flex;
  align-items: center;
}

.gap-2 {
  gap: 8px;
}

.cadastro-title {
  color: #0f2b57;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
}

/* Identificação da empresa de origem no cabeçalho */
.cadastro-origem {
  min-width: 0;
  max-width: 50%;
}

.cadastro-origem-label {
  font-size: 10px;
  font-weight: 700;
  color: #8a94a3;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  flex-shrink: 0;
}

/* Mesmo círculo usado na lista de empresas */
.cadastro-origem-numero {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #1976d2;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cadastro-origem-nome {
  font-size: 12px;
  font-weight: 600;
  color: #2c3e50;
  min-width: 0;
}

.cadastro-content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cadastro-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  color: #999;
  font-size: 14px;
}

.cadastro-scroll-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  padding: 16px 18px;
}

/* Bloco destacado do documento (CNPJ / CPF / CCE) */
.cadastro-bloco {
  border: 1px solid #e8eef4;
  border-radius: 8px;
  padding: 12px;
  background-color: #fbfdff;
}

.cadastro-bloco-titulo {
  color: #0f2b57;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin-bottom: 10px;
}

.cadastro-radio >>> .v-label {
  font-size: 13px;
  color: #2c3e50;
}

.empty-state-icon {
  opacity: 0.6;
}

.empty-state-subtitle {
  font-size: 12px;
  color: #777;
  max-width: 260px;
  margin: 0 auto;
  line-height: 1.4;
}

.cadastro-loading-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  border-radius: 4px 4px 0 0;
}
</style>
